import { Link } from "react-router-dom";
import VStack from "shared/components/layout/stack/VStack";
import { COLOR_VALUES } from "shared/config/colors";
import styled from "styled-components";

export const StyledLink = styled(Link)`
    flex: 0 0 31%;
    max-width: 31%;

    &:hover {
        color: unset;
        text-decoration: none;
    }
`;

export const AccessGroupCard = styled(VStack)`
    min-width: 10rem;
    width: 100%;
    min-height: 120px;
    background: ${COLOR_VALUES.White};
    padding: 16px 16px 8px 16px;
    border: 1px solid ${COLOR_VALUES.Gray_6};
    border-radius: 4px;
`;
